const items = (that) => [
    {
        get enabled() {
            return that?.checkPermission("chat.get");
        },
        key: "users",
        label: that?.$t(`message.users`) || "Users",
        icon: {
            type: "material-icons",
            name: "group",
        },
    },
    {
        get enabled() {
            return that && that.checkPermission("role.get");
        },
        key: "roles",
        label: that?.$t(`message.roles`) || "Roles",
        icon: {
            type: "material-icons",
            name: "safety_divider",
        },
    },
    {
        get enabled() {
            return that && that.checkPermission(["topic.create", "topic.update", "topic.delete"]);
        },
        key: "departments",
        label: that?.$t(`message.departments`) || "Departments",
        icon: {
            type: "material-icons",
            name: "domain",
        },
    },
    {
        get enabled() {
            return that && that.checkPermission("bannedVisitor.view");
        },
        key: "banned-visitors",
        label: that?.$t(`message.bannedVisitors`) || "Banned Visitors",
        icon: {
            type: "material-icons",
            name: "block",
        },
    },
];

export default items;
